import { render, staticRenderFns } from "./DBuilderLinkPopup.vue?vue&type=template&id=6ef45d4b&scoped=true&"
import script from "./DBuilderLinkPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderLinkPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderLinkPopup.vue?vue&type=style&index=0&id=6ef45d4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef45d4b",
  null
  
)

export default component.exports